import BaseService from "src/packages/BaseService";

export default class GameQuestionService extends BaseService {
	static get className () {
		return "gamequestion";
	}

	static async reorder (data) {
		const response = await BaseService.getService().post("/reorder", { data });
		return response.data;
	}
};
